import { type Components, type Theme } from "@mui/material/styles";

export const autocomplete: Components<Theme>["MuiAutocomplete"] = {
  defaultProps: {
    disableClearable: false,
    size: "small",
    slotProps: {
      paper: {
        elevation: 8,
      },
    },
  },
};
